<template>
<v-container fluid class="homeBody theme--dark">

  <div class="labelStuff">
    <div class="logoWithin">
      <div>
        <p class="logoText">Saving App</p>
      </div>
      <div class="bigLogo">
        <img src="../../assets/Circled Logo Large.png" alt="Savings App">
      </div>
    </div>
  </div>

    <v-layout column class="first-card">
      <v-flex xs12>
        <div class="resultContainer">
          <v-layout align-center justify-center row fill-height>
             <div class="item">
               <v-layout align-center justify-center row >
                 <div class="title">
                   <p>Login</p>
                 </div>
               </v-layout>

                <v-card class="welcomeCard">
                 <v-card-title>

                 </v-card-title>
                 <v-form ref="form" v-model="valid" lazy-validation class="form" @submit.prevent="authentication">
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="E-mail"
                    required
                  ></v-text-field>

                  <v-text-field
                    type="password"
                    v-model="password"
                    :rules="passwordRules"
                    label="Password"
                    required
                  ></v-text-field>

                <div class="buttonArea">
                  <v-layout align-center justify-center row>
                    <div class="foreground1">
                      <v-btn
                        flat
                        :disabled="!valid"
                        color="white"
                        block
                        type="submit"
                      >
                        LOGIN
                      </v-btn>
                    </div>

                    <div class="foreground1 cancelButton">
                      <v-btn flat block color="red"><router-link to="/" tag="span">CANCEL</router-link></v-btn>
                    </div>

                  </v-layout>

                </div>

                </v-form>

                <v-card-text>
                  <p class="text-xs-center plink">
                    <router-link to="/signup" tag="span">don't have an account with us?</router-link>
                  </p>
                </v-card-text>
                </v-card>
             </div>
    </v-layout>
        </div>
      </v-flex>

    </v-layout>
    <v-dialog
      v-model="clicked"
      width="250px"
      persistent>
        <dialog-component :type="type" :message="message" @dismiss="dismiss()"></dialog-component>
    </v-dialog>
</v-container>


</template>

<script>
import {mapGetters} from 'vuex'
export default {
   data: () => ({
      clicked: false,
      isLoading: false,
      type: '',
      message: '',
      valid: true,
      password:'',
       passwordRules: [
        v => !!v || 'Please enter a password',
        v => (v && v.length > 5) || 'Password must have at least 6 characters'
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ]
    }),
  methods: {
    authentication (e) {
      e.stopPropagation()
      // this.$store.dispatch('auth') // have to create signup method
      if (!this.$refs.form.validate()) {
        this.$store.dispatch('login',{type: 'messageOnly', message: 'No inputs yet'})
        return;
      }
      const user = {
        email: this.email,
        password: this.password
      }

      this.$store.dispatch('login', user)
    },
    stageStatus () {
       this.$store.dispatch('inStage1')
    },
    dismiss () {
       this.$store.dispatch('changeLoadAction')
       // console.log("Clicked my man!!")
      // this.clicked = true;
    }
  },
  mounted() {
    this.stageStatus()
  },
  watch: {
    loadStatus: function(loadStatus) {
      this.type = this.$store.getters.getType
      this.message = this.$store.getters.getMessage
      this.clicked = loadStatus;
      // console.log(this.$store.getters.authStatus)
      if (this.$store.getters.authStatus) {
        // this.$store.dispatch('changeLoadAction')
        this.$store.dispatch('showDialog', {type:'messageOnly', message:'Successful'})
        setTimeout(() => {
          this.$router.push('/welcome')
        },3000)
      }

     }
  },
  computed: {
    ...mapGetters([
       'loadStatus'
    ])
  }

}

</script>

<style scoped>

  .homeBody {
    padding: 0;
    background-color: #0055D4;
    height: 100%;
    width: 100%;
    position: relative;
  }


  .labelStuff {
    color: white;
    width: 100%;
    height: 100%;
    align-items: center;
    display: flex;
    justify-content: center;
    filter: blur(15px);
  }


  .labelStuff,
  .first-card {
    position: absolute;
  }


  .first-card {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .logoWithin {
    height: 400px;
    width: 400px;
    display: block;
  }


  .logoText {
    font-size: 5em !important;
    font-family: "Auriol LT Std";
    margin-top: 0;
    text-align: center;
    color: white;
  }

  .bigLogo {
    text-align: center;
  }

  .bigLogo img {
    margin-top: 20px;
    height: 270px;
    width: 270px;
  }


  .resultContainer {
    /*height: 550px;*/
   height: 100%;
    font-family: Roboto, "Helvetica Neue", sans-serif;
   display: flex;
   align-items: center;
   justify-content: center;
  }

  @media (max-width: 400px) {
    .logoText {
      font-size: 3em !important;
    }

    .item {
      margin-top: 150px;
    }

    .bigLogo img {
      margin-top: 30px;
      height: calc(50vw);
      width: calc(50vw);
    }
  }

  .welcomeCard {
    background-color: rgba(0, 85, 212, 0.8) !important;
    color: white;
    width: 290px;
  }

  .title {
    font-size: 40px !important;
  }

  .form {
    width: 80%;
    margin: auto;
  }

  .item {
    min-height: 50px;
    min-width: 300px;
    margin: 10px;

  }

  .logoText {
    font-family: 'Auriol LT Std';
    font-size: 4em;
  }

  .actions {
    width: 100%;
    position: relative;
  }

  .actions1 {
    width: 100%;
    position: relative;
  }

  .background1 {
    /* background-color: red; */
    filter: blur(5px);
    position: absolute;
    z-index: 0;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .foreground1 {
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    background-color: rgba(255,255,255,0.1) !important;
    padding-top: 0;
  }

  .cancelButton {
    background-color: rgba(255,0,0,0.1) !important;
  }
  .foreground1 .v-btn {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .v-card__title {
    padding-bottom: 0 !important;
  }

  .v-card__text p {
    margin-top: 10px !important;
  }

  .title {
    font-size: 7em !important;
    font-family: "Auriol LT Std" !important;
    color: white;
    margin-bottom: 10px;
  }

  .plink {
    cursor: pointer;
  }


   .plink:hover{
    color: #0055D4;;
  }

  .plink:active{
    color: white;
  }


  p :nth-of-type(2){
    padding-bottom: 0;
  }

   p :nth-of-type(2){
    padding-bottom: 0;
  }


  .background {
    /* background-color: white; */
    filter: blur(5px);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 35px;
  }

  .foreground {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
  }

  .background, .foreground {
    width: 100%;
    position: absolute;
  }



</style>



// WEBPACK FOOTER //
// src/components/Login/Login.vue